import DashboardLayout from '../layouts/DashboardLayout'
// import CustomerSupport from '../pages/support/CustomerSupport'

export const teacherSupportV2 = {
    path: '/customer-support-v2',
    component: DashboardLayout,
    name: 'customerSupport',
    children: [
        {
            path: '/customer-support-v2',
            component: () => import (/* webpackChunkName: "about" */'../pages/teacher-support/index.vue'),
            meta: {
                roles: 'all',
                requiresAuth: true,
                breadcrumb: [{
                    title: 'Hỗ trợ khách hàng'
                }]
            },
        },
    ],
}